/* eslint-disable prettier/prettier */
'use client';

import React from 'react';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
// import {
//   //HamburgerMenuIcon,
//   DotFilledIcon,
//   CheckIcon,
//   ChevronRightIcon,
// } from '@radix-ui/react-icons';

interface AddressBarInterface {
  isInWorkspace?: boolean;
}

export function AddressBar({ isInWorkspace }: AddressBarInterface) {
  const pathname = usePathname();
  // const [bookmarksChecked, setBookmarksChecked] = React.useState(true);
  // const [urlsChecked, setUrlsChecked] = React.useState(false);
  // const [person, setPerson] = React.useState('pedro');

  return (
    <div className="p-2 grid grid-cols-6">
      <div className="flex col-span-4 items-center gap-x-2 p-3.5 lg:px-5 lg:py-3">
        <div className="text-gray-600">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="flex gap-x-1 text-sm font-medium">
          <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild>
              <div>
                {isInWorkspace ? (
                  <Link href="/dashboard/workspaces">
                    <span className=" text-teal-100 hover:cursor-pointer no-underline px-2">
                      SimpFi<span className=" text-green-500">.Ai</span>
                    </span>
                  </Link>
                ) : (
                  <span className=" text-teal-100 hover:cursor-pointer no-underline px-2">
                    SimpFi<span className=" text-green-500">.Ai</span>
                  </span>
                )}
              </div>
            </DropdownMenu.Trigger>

            <DropdownMenu.Portal>
              {/*
              <DropdownMenu.Content
                className="DropdownMenuContent"
                sideOffset={5}
              >
                <DropdownMenu.Item className="DropdownMenuItem">
                  New Tab <div className="RightSlot">⌘+T</div>
                </DropdownMenu.Item>
                <DropdownMenu.Item className="DropdownMenuItem">
                  New Window <div className="RightSlot">⌘+N</div>
                </DropdownMenu.Item>
                <DropdownMenu.Item className="DropdownMenuItem" disabled>
                  New Private Window <div className="RightSlot">⇧+⌘+N</div>
                </DropdownMenu.Item>
                <DropdownMenu.Sub>
                  <DropdownMenu.SubTrigger className="DropdownMenuSubTrigger">
                    More Tools
                    <div className="RightSlot">
                      <ChevronRightIcon />
                    </div>
                  </DropdownMenu.SubTrigger>
                  <DropdownMenu.Portal>
                    <DropdownMenu.SubContent
                      className="DropdownMenuSubContent"
                      sideOffset={2}
                      alignOffset={-5}
                    >
                      <DropdownMenu.Item className="DropdownMenuItem">
                        Save Page As… <div className="RightSlot">⌘+S</div>
                      </DropdownMenu.Item>
                      <DropdownMenu.Item className="DropdownMenuItem">
                        Create Shortcut…
                      </DropdownMenu.Item>
                      <DropdownMenu.Item className="DropdownMenuItem">
                        Name Window…
                      </DropdownMenu.Item>
                      <DropdownMenu.Separator className="DropdownMenu.Separator" />
                      <DropdownMenu.Item className="DropdownMenuItem">
                        Developer Tools
                      </DropdownMenu.Item>
                    </DropdownMenu.SubContent>
                  </DropdownMenu.Portal>
                </DropdownMenu.Sub>

                <DropdownMenu.Separator className="DropdownMenuSeparator" />

                <DropdownMenu.CheckboxItem
                  className="DropdownMenuCheckboxItem"
                  checked={bookmarksChecked}
                  onCheckedChange={setBookmarksChecked}
                >
                  <DropdownMenu.ItemIndicator className="DropdownMenuItemIndicator">
                    <CheckIcon />
                  </DropdownMenu.ItemIndicator>
                  Show Bookmarks <div className="RightSlot">⌘+B</div>
                </DropdownMenu.CheckboxItem>
                <DropdownMenu.CheckboxItem
                  className="DropdownMenuCheckboxItem"
                  checked={urlsChecked}
                  onCheckedChange={setUrlsChecked}
                >
                  <DropdownMenu.ItemIndicator className="DropdownMenuItemIndicator">
                    <CheckIcon />
                  </DropdownMenu.ItemIndicator>
                  Show Full URLs
                </DropdownMenu.CheckboxItem>

                <DropdownMenu.Separator className="DropdownMenuSeparator" />

                <DropdownMenu.Label className="DropdownMenuLabel">
                  People
                </DropdownMenu.Label>
                <DropdownMenu.RadioGroup
                  value={person}
                  onValueChange={setPerson}
                >
                  <DropdownMenu.RadioItem
                    className="DropdownMenuRadioItem"
                    value="pedro"
                  >
                    <DropdownMenu.ItemIndicator className="DropdownMenuItemIndicator">
                      <DotFilledIcon />
                    </DropdownMenu.ItemIndicator>
                    Pedro Duarte
                  </DropdownMenu.RadioItem>
                  <DropdownMenu.RadioItem
                    className="DropdownMenuRadioItem"
                    value="colm"
                  >
                    <DropdownMenu.ItemIndicator className="DropdownMenuItemIndicator">
                      <DotFilledIcon />
                    </DropdownMenu.ItemIndicator>
                    Colm Tuite
                  </DropdownMenu.RadioItem>
                </DropdownMenu.RadioGroup>

                <DropdownMenu.Arrow className="DropdownMenuArrow" />
              </DropdownMenu.Content>
              */}
            </DropdownMenu.Portal>
          </DropdownMenu.Root>
          {pathname ? (
            <>
              {/* <span className="text-gray-600">/</span> */}
              {pathname
                .split('/')
                .slice(1)
                .map((segment) => {
                  return (
                    <React.Fragment key={segment}>
                      <span>
                        <span
                          key={segment}
                          className="animate-[highlight_1s_ease-in-out_1] rounded-full px-1.5 py-0.5 text-gray-100 text-xs"
                        >
                          {segment}
                        </span>
                      </span>

                      <span className="text-gray-600">/</span>
                    </React.Fragment>
                  );
                })}
            </>
          ) : null}
        </div>
      </div>
      <div className="col-span-1"></div>
      <div className=" col-span-1">
        <ConnectButton
          label="Connect"
          chainStatus="none"
          accountStatus="avatar"
        />
      </div>
    </div>
  );
}
